import { GameVars } from "../../../GameVars";

export class ScoreContainer extends Phaser.GameObjects.Container {

    private static readonly NUMBER_MS = 75;

    public scoreNum: number;

    private score: Phaser.GameObjects.Image[];
    private spacing: number;
    private lastX: number;
    private scoreTotal: number;
    private tween: Phaser.Tweens.Tween;
    private textureAtlas: string;

    constructor(scene: Phaser.Scene, textureAtlas: string, spacing: number = 0) {
        
        super(scene);

        this.textureAtlas = textureAtlas;
        this.score = [];
        this.spacing = spacing;
        this.lastX = this.x;
        this.scoreNum = 0;
        this.scoreTotal = 0;
        this.tween = null;
    }

    public updateScore(score: number): void {

        if (this.tween) {
            this.tween.remove();
            this.tween = null;
        }

        const scoreDelta = score - this.scoreTotal;
        this.scoreTotal = score;

        this.tween = this.scene.tweens.add({
            targets: this,
            scoreNum: score,
            duration: Math.sqrt(scoreDelta) * ScoreContainer.NUMBER_MS,
            ease: Phaser.Math.Easing.Linear,
            onUpdate: function(): void {
                this.updateScoreDigits(GameVars.formatNumber(Math.floor(this.scoreNum)).toString());
            },
            onUpdateScope: this,
            onComplete: function(): void {
                this.tween = null;
            },
            onCompleteScope: this
        });
    }   

    public updateScoreDigits(score: string): void {

        this.destroyScore();
       
        this.x = this.lastX;

        let currentX = this.x;
        const currentY = this.y;

        for (let i = 0; i < score.length; ++i) {
            const letter = new Phaser.GameObjects.Image(this.scene, currentX, currentY, this.textureAtlas, score[i]);
            letter.setOrigin(0, score[i] === ',' ? -0.25 : 0.5);
            currentX += letter.frame.width + this.spacing;

            this.score.push(letter);
            this.add(letter);
        }

        this.x -= (currentX - this.lastX) * .5;
    }

    private destroyScore(): void {

        if (this.score.length > 0) {
            for (let i = 0; i < this.score.length; ++i) {
                this.score[i].destroy();
            }
            this.score = [];
        }
    }
}
